import freeTrainGpu from "./freeTrainGpu";

export { freeTrainGpu };
export default { freeTrainGpu };
